/**
 * Layout Component
 * Main layout wrapper for all pages
 */

import { ReactNode, useEffect } from 'react'
import Navigation from './Navigation'
import Footer from './Footer'

interface LayoutProps {
  children: ReactNode
  heroImage?: string
  heroAlt?: string
}

export default function Layout({ children, heroImage, heroAlt }: LayoutProps) {
  useEffect(() => {
    // Hero parallax fade effect
    const heroImg = document.querySelector('.hero-image') as HTMLElement
    if (!heroImg) return

    const heroHeight = heroImg.offsetHeight
    let ticking = false

    const updateOpacity = () => {
      const scrollPosition = window.scrollY
      const opacity = Math.max(0, Math.min(1, 1 - scrollPosition / heroHeight))
      heroImg.style.opacity = String(opacity)
      ticking = false
    }

    const requestTick = () => {
      if (!ticking) {
        requestAnimationFrame(updateOpacity)
        ticking = true
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true })
    return () => window.removeEventListener('scroll', requestTick)
  }, [heroImage])

  return (
    <>
      <header>
        <Navigation />
      </header>

      <main>
        {heroImage && (
          <div className="hero">
            <img
              src={heroImage}
              alt={heroAlt || ''}
              className="hero-image"
              decoding="async"
            />
          </div>
        )}
        <div className="container">{children}</div>
      </main>

      <Footer />
    </>
  )
}
